export class User {
  constructor() {
    this.id = "";
    this.firstName = "";
    this.lastName = "";
    this.title = "";
    this.relationship = "";
    this.gender = null;
    this.race = null;
    this.telNumber = "";
    this.altNumber = "";
    this.email = "";
    this.businessEmail = "";
    this.faxNumber = "";
    this.dob = "";
    this.age = 0;
    this.idNumber = "";
    this.passport = "";
    this.fullAddress = "";
    this.postalCode = "";
    this.region = "";
    this.regionName = "";
    this.industry = null;
    this.industryName = "";
    this.bio = "";
    this.rating = 0;
    this.role = "";
    this.contactRole = "";
    this.consultant = null;
    this.consultantName = "";
    this.referral = null;
    this.relationship = null;
    this.existingProducts = null;
    this.productsInterestedIn = null;
    this.referralNumber = "";
    this.source = null;
    this.companyName = "";
    this.contactType = "";
    this.contactTypeName = "";
    this.updatedBy = null;
    this.updatedByName = "";
    this.profileStatus = null;
    this.managementCompany = null;
    this.star = null;
    this.unsubscribe = null;
    this.intNumber = "";
    this.hqNames = [];
  }

  get fullName() {
    var toArray = [this.firstName, this.lastName];
    return toArray
      .filter((item) => item)
      .join(" ")
      .trim();
  }
}
